import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import * as snackbarsActions from '../../../actions/snackbars';
import SubcontractorsStatsView from './SubcontractorsStatsView';
import documentKpiService from '../../../services/documentKpi/DocumentKpiService';
import {captureError} from '../../../utils/log';
import relationshipService from '../../../services/relationship/RelationshipService';

function SubcontractorsStatsContainer({loading}) {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [statCount, setStatCount] = useState({
    loading: true,
    value: 0
  });
  const [statDossierState, setStatDossierState] = useState({
    loading: true,
    error: null,
    values: {}
  });
  const [statDocuments, setStatDocuments] = useState({
    loading: true,
    error: null,
    values: {}
  });

  function getSubcontractorsCount() {
    relationshipService.getSubcontractorsCountByUser(user.id)
      .then(response => {
        setStatCount({
          value: response,
          loading: false
        });
      })
      .catch(error => {
        setStatCount({loading: false});
        captureError('Error while getting global subcontractors count', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  function getDocumentsStats() {
    if (selectedCountry === '') {
      setStatDocuments({
        values: {},
        loading: false,
        error: 'message.noData'
      });
      return;
    }

    setStatDocuments({
      values: {},
      loading: true,
      error: null
    });

    documentKpiService.getSubcontractorsDocumentsPercentageByDocumentStateByUser(user.id, selectedCountry)
      .then(response => {
        setStatDocuments({
          values: response,
          loading: false,
          error: Object.keys(response).length === 0 ? 'message.noData' : null
        });
      })
      .catch(error => {
        captureError('Error while getting global subcontractors documents states', error);
        setStatDocuments({
          values: {},
          loading: false,
          error: 'error.generic'
        });
      });
  }

  function getDossierStatesStats() {
    documentKpiService.getValidSubcontractorsDossierStatesPercentageByUser(user.id)
      .then(response => {
        const noResult = Object.keys(response).length === 0;
        setStatDossierState({
          values: response,
          loading: false,
          error: noResult ? 'message.noData' : null
        });
        setSelectedCountry(noResult ? '' : Object.keys(response)[0]);
      })
      .catch(error => {
        captureError('Error while getting global subcontractors dossier states', error);
        setStatDossierState({
          values: {},
          loading: false,
          error: 'error.generic'
        });
      });
  }

  React.useEffect(() => {
    if (!loading) {
      getSubcontractorsCount();
      getDossierStatesStats();
    }
  }, [loading]);

  React.useEffect(() => {
    if (selectedCountry !== null) {
      getDocumentsStats();
    }
  }, [selectedCountry]);

  return (
    <SubcontractorsStatsView
      selectedCountry={selectedCountry}
      onCountryChange={event => setSelectedCountry(event.target.value)}
      statCount={statCount}
      statDossierState={statDossierState}
      statDocuments={statDocuments}
    />
  );
}

SubcontractorsStatsContainer.propTypes = {
  loading: PropTypes.bool
};

export default SubcontractorsStatsContainer;
